import React, { useState, useEffect } from 'react';
import { DocumentsServices } from '../../services';
import './style.css';
import { Carousel, Calculator, FileList } from '../../components';

import proposta from '../../files/proposta.pdf';

function Home() {
  const [news, setNews] = useState([]);
  useEffect(() => {
    async function fetchNews() {
      try {
        const response = await DocumentsServices.fetchDocuments('news', {
          params: { limitation: 3 }
        });
        setNews(response.data);
      } catch (error) {
        console.log(error);
      }
    }

    fetchNews();
  }, []);
  return (
    <>
      <Carousel />
      <div id="home-body">
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div className="news-preview-container">
            <h2>Notícias</h2>
            <FileList  files={news || []} />
          </div>
          <div className="about-content">
            <h2>Como se associar?</h2>
            <p>
              Para associar-se, basta solicitar ficha de Proposta de Sócio, através do nosso e-mail (<a href="#">email@gmail.com</a>),
              solicitar ao diretor de sua área, vir na sede da cooperativa ou até mesmo <a href={proposta} target="_blank" rel="noreferrer">aqui</a>, pelo site.
            </p>
            <Calculator />
          </div>
        </div>
        <div>
          <h2>Locais e horários de atendimento</h2>
          <ul className="details-list">
            <li>
              <p>
                <b>Endereço</b>: Núcleo D-67, 149 vila AFP - Charqueadas / RS.
              </p>
            </li>
            <li>
              <p>
                <b>Horário de atendimento</b>: De segunda-feira à sexta-feira, das 08:00h ás 18:00h (sem fechar ao meio-dia). 
              </p>
            </li>
            <li>
              <p>
                <b>Fale conosco</b>: (51) 99548-0598.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Home;